<template>
  <div class="benefit-card-page">
    <GreetingCard
      :visible="showGreetingCard"
      :card-image="currentGreetingCard?.imageUrl"
      :blessing="currentGreetingCard?.blessing"
      :need-signature="currentGreetingCard?.needSignature === '1'"
      @button-click="handleGreetingCardButtonClick"
    />
    <SignaturePad
      :visible="showSignature"
      :signature-options="signatureOptions"
      @close="closeSignature"
      @confirm="handleSignatureConfirm"
    />
    <div class="benefit-card-header">
      <div class="sort-bar">
        <button
          type="button"
          class="sort-chip"
          :class="{ active: sortMode === 'default' }"
          @click="timeB"
        >默认推荐</button>
        <button
          type="button"
          class="sort-chip"
          :class="{ active: sortMode === 'expire' }"
          @click="timeL"
        >即将过期</button>
        <button
          type="button"
          class="sort-chip sort-chip--point"
          :class="{ active: sortMode === 'point-asc' || sortMode === 'point-desc' }"
          @click="numChange"
        >
          点数
          <van-icon
            v-if="sortMode === 'point-asc' || sortMode === 'point-desc'"
            :name="sortMode === 'point-desc' ? 'arrow-down' : 'arrow-up'"
            size="0.75rem"
          />
        </button>
      </div>
    </div>

    <div class="benefit-card-scroll">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="benefit-card-content">
          <BindCardActions
            :ticket-type="form.ticketType"
            @bind-success="onBindSuccess"
          />

          <van-list v-model="loading" :finished="finished" @load="onLoad">
            <div
              v-for="(item, index) in cardData"
              :key="item.cardNo || item.cardId || index"
              class="benefit-card-item"
              :style="{ backgroundImage: 'url(' + getback(item.themeImg, index) + ')' }"
              @click="toDetail(item, index)"
            >
              <div class="benefit-card-item__inner">
                <div class="benefit-card-item__top">
                  <span class="benefit-card-item__no">卡号 {{ item.cardNo }}</span>
                  <span class="benefit-card-item__expire">
                    {{ $moment(item.expireDate).format('YYYY.MM.DD') }} 到期
                  </span>
                </div>
                <div class="benefit-card-item__middle">
                  <p class="benefit-card-item__name">
                    {{ getCardName(item.cardShowName || item.cardName) }}
                  </p>
                  <p class="benefit-card-item__point">
                    {{ item.cardRemainingPoint }}<span class="benefit-card-item__unit">{{ item.cardPointTypeUnit }}</span>
                  </p>
                </div>
                <div class="benefit-card-item__bottom">
                  <span v-if="form.ticketType == 'E4' && item.upgradeFlag == '1'" class="benefit-card-item__badge">升级版</span>
                  <span v-else></span>
                  <div class="benefit-card-item__actions">
                    <span
                      v-if="canUpgrade(item)"
                      :class="actionBtnClass(item, index)"
                      @click.stop="upgrade(item)"
                    >升级</span>
                    <span
                      :class="actionBtnClass(item, index)"
                      @click.stop="toview(item)"
                    >去使用</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>

          <div v-if="!loading && cardData.length === 0" class="benefit-card-empty">
            暂无可用福利卡，请先扫码绑卡或券密绑定
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { cacheCardInfo } from '../index.action';
import { clearCategoryNavCache } from '@/utils/categoryNav';
import BindCardActions from './BindCardActions.vue';
import GreetingCard from './GreetingCard.vue';
import SignaturePad from './SignaturePad.vue';

export default {
  name: 'BenefitCardListPanel',
  components: { BindCardActions, GreetingCard, SignaturePad },
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      imageback: require('@/assets/images/card_bg.svg'),
      imageback2: require('@/assets/images/card_bg2.svg'),
      cardData: [],
      showGreetingCard: false,
      showSignature: false,
      signatureOptions: {
        penColor: '#000000',
        backgroundColor: '#ffffff',
      },
      greetingCardQueue: [],
      currentGreetingCard: null,
      form: {
        userId: '',
        size: 50,
        current: 1,
        usableType: '1',
        ticketType: '',
        numType: '',
        timType: '',
      },
    };
  },
  computed: {
    sortMode() {
      if (this.form.timType === '1') return 'expire';
      // 与后端约定：numType 0=点数降序，1=点数升序
      if (this.form.numType === '0') return 'point-desc';
      if (this.form.numType === '1') return 'point-asc';
      return 'default';
    },
  },
  activated() {
    this.refreshIfCardBack();
  },
  methods: {
    /** 券密绑定页返回后会写入 cardback，需刷新列表 */
    refreshIfCardBack() {
      if (!localStorage.getItem('cardback')) return false;
      localStorage.removeItem('cardback');
      this.onRefresh();
      return true;
    },
    initFromRoute(route) {
      this.greetingCardQueue = [];
      this.currentGreetingCard = null;
      this.showGreetingCard = false;
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        this.form.userId = JSON.parse(userInfo).id;
      }
      this.form.ticketType = route.query.ticketType || localStorage.getItem('entrCode') || '';
      localStorage.setItem('entrCode', this.form.ticketType);
      this.syncMallSource();
      if (this.refreshIfCardBack()) {
        return Promise.resolve();
      }
      return this.resetAndLoad();
    },
    syncMallSource() {
      if (this.form.ticketType === 'E6') {
        localStorage.setItem('mallSource', 'giftPackage');
      } else if (localStorage.getItem('mallSource')) {
        localStorage.removeItem('mallSource');
      }
      window.dispatchEvent(new Event('mallSourceChange'));
    },
    resetAndLoad() {
      this.form.current = 1;
      this.finished = false;
      this.cardData = [];
      return this.getCard();
    },
    timeB() {
      this.form.timType = '';
      this.form.numType = '';
      this.onRefresh();
    },
    timeL() {
      this.form.timType = '1';
      this.form.numType = '';
      this.onRefresh();
    },
    numChange() {
      this.form.timType = '';
      this.form.numType = this.form.numType !== '0' ? '0' : '1';
      this.onRefresh();
    },
    getCardName(str) {
      if (!str) return '';
      return str.length > 12 ? `${str.substring(0, 12)}…` : str;
    },
    canUpgrade(item) {
      return item.ifUpgrade == '1' && (item.upgradeFlag == '0' || item.upgradeFlag == '' || !item.upgradeFlag);
    },
    toDetail(item, index) {
      localStorage.setItem('itemDetail', JSON.stringify(item));
      this.$router.push({
        path: '/UserDetail',
        query: { index, activity: '1' },
      });
    },
    onRefresh() {
      this.form.current = 1;
      this.finished = false;
      this.loading = true;
      // 先本地重排，避免清空列表导致「点了没反应」；接口返回后再覆盖
      if (this.cardData.length) {
        this.cardData = this.sortCardRecords(this.cardData);
      } else {
        this.cardData = [];
      }
      this.getCard();
    },
    onLoad() {
      if (this.cardData.length >= 1) {
        this.form.current += 1;
        this.getCard();
      }
    },
    /** 与后端 BingBenefitCardDTO 约定：timType/numType 为 1 升序、0 降序；默认按到期日+点数 */
    sortCardRecords(list) {
      const rows = [...(list || [])];
      const toTime = (val) => {
        const t = new Date(val).getTime();
        return Number.isNaN(t) ? 0 : t;
      };
      const toPoint = (val) => {
        const n = parseFloat(val);
        return Number.isNaN(n) ? 0 : n;
      };

      if (this.form.numType === '0') {
        return rows.sort((a, b) => toPoint(b.cardRemainingPoint) - toPoint(a.cardRemainingPoint));
      }
      if (this.form.numType === '1') {
        return rows.sort((a, b) => toPoint(a.cardRemainingPoint) - toPoint(b.cardRemainingPoint));
      }
      if (this.form.timType === '1') {
        return rows.sort((a, b) => toTime(a.expireDate) - toTime(b.expireDate));
      }
      if (this.form.timType === '0') {
        return rows.sort((a, b) => toTime(b.expireDate) - toTime(a.expireDate));
      }
      // 默认推荐：即将到期优先，同到期日按点数从少到多
      return rows.sort((a, b) => {
        const d = toTime(a.expireDate) - toTime(b.expireDate);
        if (d !== 0) return d;
        return toPoint(a.cardRemainingPoint) - toPoint(b.cardRemainingPoint);
      });
    },
    getCard() {
      const payload = {
        ...this.form,
        // 空字符串时显式不传，避免后端 MyBatis 判断异常
        numType: this.form.numType || undefined,
        timType: this.form.timType || undefined,
      };
      return this.$api
        .cardList(payload)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
            this.loading = false;
            this.isLoading = false;
            if (this.form.current === 1) {
              this.$emit('cards-loaded', this.cardData);
            }
            return res;
          }
          let records = res.data.records || [];
          // 首页结果在前端再排一次，保证排序按钮即时生效（后端 ORDER BY 条件历史上有 bug）
          if (this.form.current === 1) {
            records = this.sortCardRecords(records);
          }
          if (this.form.current == 1) {
            this.cardData = records;
          } else {
            this.cardData.push(...records);
          }
          this.finished = this.form.current >= res.data.pages;
          this.loading = false;
          this.isLoading = false;
          this.$emit('cards-loaded', this.cardData);
          if (this.form.current === 1) {
            this.checkPendingGreetingCards(this.cardData);
          }
          return res;
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
          this.isLoading = false;
          // 首屏失败也需结束父页 loading（424 时拦截器会跳登录）
          if (this.form.current === 1) {
            this.$emit('cards-loaded', this.cardData);
          }
        });
    },
    onBindSuccess() {
      this.onRefresh();
    },
    /** 列表加载后弹出未签收的贺卡（登录入口与 Tab 页共用） */
    checkPendingGreetingCards(cardList) {
      if (!cardList || cardList.length === 0) return;
      const greetingCards = cardList.filter((card) => card.showGreetingCard === '1');
      if (greetingCards.length === 0) return;
      const existingIds = new Set(this.greetingCardQueue.map((card) => card.id));
      const newCards = greetingCards.filter((card) => !existingIds.has(card.id));
      if (newCards.length === 0) return;
      this.greetingCardQueue.push(...newCards);
      if (!this.showGreetingCard) {
        this.showNextGreetingCard();
      }
    },
    showNextGreetingCard() {
      if (this.greetingCardQueue.length > 0) {
        this.currentGreetingCard = this.greetingCardQueue.shift();
        this.showGreetingCard = true;
      }
    },
    handleGreetingCardButtonClick() {
      if (!this.currentGreetingCard) return;
      if (this.currentGreetingCard.needSignature === '1') {
        this.showSignature = true;
      } else {
        this.saveGreetingCardSignature(null);
      }
    },
    saveGreetingCardSignature(signatureDataURL) {
      if (!this.currentGreetingCard) return;
      const params = {
        spuId: this.currentGreetingCard.spuId,
        cardId: this.currentGreetingCard.cardId,
      };
      if (signatureDataURL) {
        params.signatureImage = signatureDataURL.includes(',')
          ? signatureDataURL.split(',')[1]
          : signatureDataURL;
      }
      this.$api
        .saveGreetingCardSignature(params)
        .then((res) => {
          if (res.code === 0) {
            this.$Toast.success('签收成功');
            this.showSignature = false;
            this.showGreetingCard = false;
            this.currentGreetingCard = null;
            setTimeout(() => this.showNextGreetingCard(), 300);
          } else {
            this.$Toast.fail(res.msg || '签收失败');
          }
        })
        .catch(() => {
          this.$Toast.fail('签收失败');
        });
    },
    closeSignature() {
      this.showSignature = false;
    },
    handleSignatureConfirm(signatureDataURL) {
      this.saveGreetingCardSignature(signatureDataURL);
    },
    getback(str, index) {
      if (str) return str;
      return index % 2 === 0 ? this.imageback : this.imageback2;
    },
    getColorType(str, index) {
      if (!str) return index % 2 === 0 ? 1 : 2;
      return 1;
    },
    actionBtnClass(item, index) {
      return this.getColorType(item.themeImg, index) === 1
        ? 'benefit-card-item__action benefit-card-item__action--warm'
        : 'benefit-card-item__action benefit-card-item__action--cool';
    },
    toview(val) {
      if (val.cardInitPoint == 0) {
        localStorage.setItem('isPreviewMode', 'true');
      } else {
        localStorage.removeItem('isPreviewMode');
      }
      cacheCardInfo(val);
      if (val.ifCakeCardEnum == 'CAKE_CARD') {
        this.$router.push({ path: '/CakaHome' });
      } else if (val.ifCakeCardEnum == 'MOVIE_CARD') {
        this.$router.push({ path: '/MoviesHome' });
      } else if (val.ticketType === 'E6') {
        localStorage.setItem('mallSource', 'giftPackage');
        window.dispatchEvent(new Event('mallSourceChange'));
        this.$router.push({ path: '/GiftPackageHome' });
      } else {
        this.$api
          .isHomeShow({ bathId: val.id, upgradeFlag: val.upgradeFlag })
          .then((res) => {
            localStorage.setItem('homeShow', res.data ? '1' : '0');
            window.dispatchEvent(new Event('cardChange'));
            if (res.data) {
              this.$router.push({ path: '/HomeNew', query: { cardShowFlag: val.cardShowFlag } });
            } else {
              clearCategoryNavCache();
              this.$router.push({ path: '/GoodsList', query: { activityId: val.id } });
            }
          })
          .catch(() => {
            this.$Toast.fail('获取配置失败');
          });
      }
    },
    upgrade(val) {
      localStorage.setItem('cardItem', JSON.stringify(val));
      this.$router.push({ path: '/UpdateCard', query: { ticketType: this.form.ticketType } });
    },
  },
};
</script>

<style lang="scss" scoped>
.benefit-card-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
}

.benefit-card-header {
  flex-shrink: 0;
  background: #fff;
  padding: 0.75rem 1rem 0.65rem;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.sort-bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sort-chip {
  border: 1px solid #e8e8e8;
  background: #fff;
  color: #666;
  font-size: 0.8125rem;
  line-height: 1;
  padding: 0.45rem 0.75rem;
  border-radius: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;

  &.active {
    color: #d33b2e;
    border-color: rgba(211, 59, 46, 0.35);
    background: #fff5f4;
    font-weight: 500;
  }

  &--point.active .van-icon {
    color: #d33b2e;
  }
}

.benefit-card-scroll {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 4.5rem;
}

.benefit-card-content {
  padding: 0.75rem 1rem 1rem;
}

.benefit-card-item {
  position: relative;
  height: 11.5rem;
  margin-bottom: 0.75rem;
  border-radius: 0.875rem;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.benefit-card-item__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 0.9rem 1rem 1rem;
  box-sizing: border-box;
}

.benefit-card-item__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  color: #fdfafa;
  font-size: 0.75rem;
}

.benefit-card-item__no {
  color: #fff;
}

.benefit-card-item__expire {
  flex-shrink: 0;
  color: #fdfafa;
}

.benefit-card-item__middle {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.75rem;
}

.benefit-card-item__name {
  margin: 0;
  color: #fff;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
}

.benefit-card-item__point {
  margin: 0;
  color: #fff;
  font-size: 1.25rem;
  font-weight: 700;
  white-space: nowrap;
}

.benefit-card-item__unit {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-left: 0.1rem;
}

.benefit-card-item__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.benefit-card-item__badge {
  color: #fff;
  font-size: 0.8125rem;
  opacity: 0.95;
}

.benefit-card-item__actions {
  display: flex;
  gap: 0.45rem;
  margin-left: auto;
}

.benefit-card-item__action {
  min-width: 3.5rem;
  padding: 0.25rem 0.65rem;
  border-radius: 1rem;
  background: #fff;
  font-size: 0.8125rem;
  text-align: center;

  &--warm {
    color: #d59a54;
  }

  &--cool {
    color: #6354ff;
  }
}

.benefit-card-empty {
  padding: 2.5rem 1rem;
  text-align: center;
  color: #999;
  font-size: 0.875rem;
}
</style>
